import {AbstractPlayableContent, TemporalIndicators} from "./AbstractPlayableContent";
import {computePlayableTimeline} from "../utils/PlayableFactory";

export class Part extends AbstractPlayableContent {
  public readonly lyrics: string;

  constructor(partId: number, temporalIndicators: TemporalIndicators, baseModel: any) {
    const playableTimeline = computePlayableTimeline(baseModel.section_timeline, 'section');

    super('part', partId, baseModel.play_name, temporalIndicators, baseModel, playableTimeline);

    if (baseModel.indexed_lyrics) {
      this.lyrics = baseModel.indexed_lyrics[temporalIndicators.indexInParentTimeline];
    }
    else {
      this.lyrics = '';
    }
  }
}
